import angular from 'angular'
import _ from 'lodash'
import intl from 'react-intl-universal'

export default ['$scope', 'snowballService', 'toastr', snowballController]

function snowballController($scope, snowballService, toastr) {
  this.intl = intl
  this.disabled = false
  this.zeroResults = false
  this.remoteTickerMemory = [] // used for zeroResults detection.
  this.existingStockSymbols = []
  this.tickers = []
  this.staleTickers = []
  this.addTicker = function(ticker) {
    this.zeroResults = false
    if (
      !Object.prototype.hasOwnProperty.call(
        this.storyObj.taxonomy,
        'stock_symbols'
      )
    ) {
      this.storyObj.taxonomy.stock_symbols = []
    }
    this.storyObj.taxonomy.stock_symbols.push(ticker)
    this.storyObj.taxonomy.stock_symbols = _.uniq(
      this.storyObj.taxonomy.stock_symbols
    )
    for (let idx = 0; idx < this.tickers.length; idx++) {
      if (this.tickers[idx] === ticker) {
        this.tickers.splice(idx, 1)
        break
      }
    }
    // Replacing the ARRAY within ngModel.$viewValue will break the watchers...
    //  so we have to scan it.
    // this.ngModel.$viewValue = _.uniq(this.ngModel.$viewValue)
    let tickerFound = false
    for (let idx = 0; idx < this.ngModel.$viewValue.length; idx++) {
      let entry = this.ngModel.$viewValue[idx]
      if (entry['text'] === ticker) {
        tickerFound = true
        break
      }
    }
    if (tickerFound === false) {
      this.ngModel.$viewValue.push({ text: ticker })
      $scope.$applyAsync(
        function() {
          this.ngModel.$render()
        }.bind(this)
      )
    }
  }.bind(this)
  this.runSnowball = function() {
    this.disabled = true
    snowballService
      .fetchSuggestions(snowballService.eatStoryObj(this.storyObj))
      .then(
        function(suggestions) {
          const freshSuggestions = []
          const staleSuggestions = []
          let newResultFound = false
          for (let idx = 0; idx < suggestions.length; idx++) {
            let suggestion = suggestions[idx]
            if (
              this.storyObj.taxonomy.stock_symbols === null ||
              angular.isUndefined(this.storyObj.taxonomy.stock_symbols)
            ) {
              this.storyObj.taxonomy.stock_symbols = []
            }
            if (this.storyObj.taxonomy.stock_symbols.indexOf(suggestion) >= 0) {
              staleSuggestions.push(suggestion)
            } else {
              freshSuggestions.push(suggestion)
            }
            if (this.remoteTickerMemory.indexOf(suggestion) < 0) {
              this.remoteTickerMemory.push(suggestion)
              newResultFound = true
            }
          }

          this.zeroResults = !newResultFound
          this.tickers = _.uniq(freshSuggestions)
          this.staleTickers = _.uniq(staleSuggestions)
          this.disabled = false
        }.bind(this)
      )
      .catch((error) => {
        console && console.error('fetchSuggestions error: ', error)
        this.disabled = false
        toastr.error(intl.get('snowball.runSnowball.error'), {
          timeOut: '20000',
        })
      })
  }.bind(this)
}
